export default {"src":"/_next/static/media/parachuting_gift.2d14e37f.svg","height":320,"width":291};